import Link from 'next/link';
import React from 'react';
import { PrismicAccountAwardProcess } from '../../types/prismic';
import { GenericAwardStatus } from './Account';
import Box, { Header, IconBox } from './Box';

type Props = {
  handleAwardClick: () => void;
  processClosed: boolean;
  awardStatus: GenericAwardStatus;
  content: PrismicAccountAwardProcess;
};

const GenericAwardProcess = ({
  handleAwardClick,
  processClosed,
  awardStatus,
  content,
}: Props) => {
  const applicationEnabled =
    !processClosed && awardStatus === GenericAwardStatus.AVAILABLE;

  return (
    <Box
      enabled={applicationEnabled}
      onClick={handleAwardClick}
      footnote={
        <>
          {!processClosed &&
            awardStatus === GenericAwardStatus.PROFILE_UPDATE_REQUIRED && (
              <>{content.data.account_award_create_profile}</>
            )}
          {awardStatus === GenericAwardStatus.SUBMITTED && (
            <>
              {content.data.account_award_registration_submitted}{' '}
              <Link href="/award">
                <a>
                  {
                    content.data
                      .account_award_registration_submitted_call_to_action
                  }
                </a>
              </Link>
            </>
          )}
        </>
      }
    >
      <IconBox>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="38.154"
          height="38.147"
          viewBox="0 0 38.154 38.147"
        >
          <path
            id="np_award_954124_000000"
            d="M24.067,5A13.964,13.964,0,0,0,12.4,26.665L5.14,37.143a.848.848,0,0,0,.874,1.311l5.576-1.113,1.483,5.179a.848.848,0,0,0,1.536.225l6.463-10.092a14.252,14.252,0,0,0,5.987,0l6.463,10.092a.848.848,0,0,0,1.536-.225l1.483-5.179,5.576,1.113a.848.848,0,0,0,.874-1.311L35.748,26.679A13.99,13.99,0,0,0,24.066,5Zm0,1.7A12.291,12.291,0,1,1,11.775,18.983,12.279,12.279,0,0,1,24.067,6.691Zm-5.934,6.358a.848.848,0,1,0,0,1.7H30a.848.848,0,1,0,0-1.7Zm-2.119,5.086a.848.848,0,1,0,0,1.7H32.119a.848.848,0,1,0,0-1.7Zm2.119,5.086a.848.848,0,1,0,0,1.7H30a.848.848,0,1,0,0-1.7ZM13.471,28.1a14.019,14.019,0,0,0,5.894,4.066L14.2,40.24,13.02,36.121a.849.849,0,0,0-.993-.6l-4.291.861Zm21.192.015L40.4,36.388l-4.291-.861a.846.846,0,0,0-.993.6l-1.179,4.119-5.166-8.079a14.054,14.054,0,0,0,5.894-4.053Z"
            transform="translate(-4.99 -4.996)"
            fill="#ab5742"
          />
        </svg>
      </IconBox>
      <Header>{content.data.account_award_header}</Header>
      {awardStatus !== GenericAwardStatus.SUBMITTED && processClosed && (
        <p>{content.data.account_award_closed_description}</p>
      )}
      {awardStatus !== GenericAwardStatus.SUBMITTED && !processClosed && (
        <p>{content.data.account_award_apply_description}</p>
      )}
      {awardStatus === GenericAwardStatus.SUBMITTED && (
        <p>{content.data.account_award_pending_description}</p>
      )}
    </Box>
  );
};

export default GenericAwardProcess;
